import { html } from 'lit';
import componentStyles from './email-signup.css.lit.ts';
import QueryComponent from '../../base/query-component/QueryComponent.js';

export default class EmailSignup extends QueryComponent {
  static styles = [super.styles, componentStyles];
  static get properties() {
    return {
      header: { type: String },
      privacy: { type: String },
      buttonText: { type: String },
      emailValue: { type: String },
      linkValue: { type: String },
      linkTarget: { type: String },
    };
  }

  constructor() {
    super();
    this.emailValue = '';
  }

  _handleChange(e) {
    this.emailValue = e.target.value;
  }

  render() {
    return html`<div class="email-signup__container">
      <div class="email-signup__input">
        <hf-heading class="email-signup__input-heading" level="2" levelStyle="heading2"
          >${this.header}</hf-heading
        >
        <hf-button
          type="${this._mediaQuery('sm') ? 'primary' : 'compact-text'}"
          href="${this.linkValue}"
          target="${this.linkTarget}"
          class="email-signup__input-submit"
          >${this.buttonText}</hf-button
        >
      </div>
      <hf-paragraph class="email-signup__privacy" styleclass="legal-footer"
        >${this.privacy}</hf-paragraph
      >
    </div>`;
  }
}

customElements.define('hf-email-signup', EmailSignup);
